import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../client";
import type { Workspace } from "../types";

export function workspaceKey(slug: string) {
  return ["workspace", slug] as const;
}

export function useWorkspace(slug: string): UseQueryResult<Workspace, ApiError> {
  return useQuery<Workspace, ApiError>({
    queryKey: workspaceKey(slug),
    queryFn: ({ signal }) => apiFetch<Workspace>(`/api/ws/${slug}`, { signal }),
    enabled: !!slug,
  });
}
